import { ErrorHandler, Injectable, Injector, inject } from '@angular/core';
import { LoggingService } from './logging.service';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { GcmNotificationService } from '@gcm/gcm-ui-angular';
import { EnvironmentVariablesService } from './environment-variables.service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    private injector = inject(Injector);
    private notificationservice = inject(GcmNotificationService);
    private environmentService = inject(EnvironmentVariablesService);

    handleError(error: HttpErrorResponse) {
        const loggingService = this.injector.get(LoggingService);
        const location = this.injector.get(LocationStrategy);
        const url = location instanceof PathLocationStrategy ? location.path() : '';
        if (this.environmentService.notificationConfig['showNotification']) {
            this.notificationservice.notifyError(error);
        }
        // Always log errors
        loggingService.log(url, error);
    }
}